export const DOMAIN_NAME = process.env.DOMAIN_NAME
export const MODE = process.env.MODE
export const PREFIX = process.env.PREFIX



// WEBPACK FOOTER //
// ./src/api/Constants.js